<template>
  <div class="container-fluid mt-2" style="font-family:'Courier New'">
    <div class="text-center">
      <span v-if="userData.logo != 0"><img :src="getFiles(userData.logo)" height="40" /></span>
      <span v-else><img src="@/assets/images/default.jpg" height="40" /></span><br>
      <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
      <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
      <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br><br>
      <span style="color: black;font-size:13px" class="text-decoration-underline"><b>REGISTRATION FEE
          PAYMENT</b></span><br>
    </div>
    <div class="row text-left">
      <div class="col-4 mx-auto">
        <table class="table ms-2">
          <tr>
            <td> Full Name </td>
            <td> <b class=" h7">{{ member.name }} </b></td>
          </tr>
          <tr>
            <td> Member ID </td>
            <td> <b class=" h7">{{ member.member_id }} </b></td>
          </tr>
          <tr>
            <td> Gender </td>
            <td> <b class=" h7">{{ member.gender }} </b></td>
          </tr>
          <tr>
            <td> Telephone </td>
            <td> <b class=" h7">0{{ member.telephone }} </b></td>
          </tr>
          <tr>
            <td> Address </td>
            <td> <b class=" h7">{{ member.address }} </b></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="text-center">
      <span style="color: black;font-size:14px"><b> AMOUNT PAID : {{ commas(amount_paid) }} {{ userData.currency
          }}</b></span><br>
      <span style="color:black;font-size:13px">{{ mode_of_payment }} : {{ reference }}</span><br>
      <span style="color: black;font-size:14px"><b> DATE : {{ (date_of_payment) }}</b></span><br>
      <br>
      <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br> On : {{ new Date().toLocaleString() }}
        <br> Printed via Namirembe Diocese Young Sacco Software
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      member: [],
      id: '',
      amount_paid: 0,
      date_of_payment: "",
      mode_of_payment: "",
      reference: ''
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async fetchInfo() {
      this.id = this.$route.query.id;
      let url = `/findregistrationfees/${this.id}`;
      await axios.get(url).then((response) => {
        this.member = response.data.registrationfees[0].member;
        this.amount_paid = response.data.registrationfees[0].amount;
        this.date_of_payment = response.data.registrationfees[0].date_of_payment;
        this.mode_of_payment = response.data.registrationfees[0].mode_of_payment.name;
        this.reference = response.data.registrationfees[0].reference;
        setTimeout(() => { window.print(); window.onafterprint = this.$router.go(-1); }, 1000);
      });
    },
  },
};
</script>